export class User {
    id: number;
    name: string;
    userName: string;
    email: string;
}
